import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';

export const getCustomerServicesAvailableToRedirect = createAsyncThunk('redirectMobileBox/getCustomerServicesAvailableToRedirect', async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());

      const result = await ProviderManager.getProviderData('getCustomerActiveCellularList', []);
      return result;
    } catch (error) {
      return {Body: {userMobileNumbers: [], error: true}};
    } finally {
      thunkAPI.dispatch(hideAppLoader());
    }
  }
);

const redirectMobileBoxSlice = createSlice({
  name: 'redirectMobileBox',
  initialState: {
    userMobileNumbers: [],
    fatalError: null,
  },
  reducers: {
    setUserMobileNumbersRedirect: (state, action) => {
      state.userMobileNumbers = [action.payload];
    },
  },
  extraReducers: {
    [getCustomerServicesAvailableToRedirect.fulfilled]: (state, action) => {
      return {
        ...state,
        userMobileNumbers: action.payload.Body ? action.payload.Body : [],
        fatalError: action.payload.Body.error ? action.payload.Body.error : false,
      };
    },
  },
});

export const {setUserMobileNumbersRedirect} = redirectMobileBoxSlice.actions;

export default redirectMobileBoxSlice.reducer;
